"use client";

import { useRouter } from "next/navigation";
import { Button } from "@shared/src/components/ui/button";

export default function NotFound() {
  const router = useRouter();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4">
      <div className="text-center space-y-4">
        <h1 className="text-4xl font-bold text-primary">404</h1>
        <h2 className="text-2xl font-semibold text-foreground">Page Not Found</h2>
        <p className="text-muted-foreground">{"The page you're looking for doesn't exist or has been moved."}</p>
        <Button variant="primary" onClick={() => router.push("/")} size="cta" radius="full" className="mt-4">
          Return Home
        </Button>
      </div>
    </div>
  );
}
